export default __webpack_public_path__ + "static/PC_2_1-703ca7c3384c7df03c69791f4ede92db.png";